import { locales } from "./index";

export const SupportedAmountLocales = new Map<locales, string>([
    ["en", "en"],
    ["es", "es-mx"],
    ["fr", "fr"],
    ["de", "de"],
    ["it", "it"],
    ["pt", "pt"],
    ["tr", "tr"],
    ["nl", "nl"],
    ["pl", "pl"],
    ["ru", "ru"],
    ["zh", "zh-hk"],
    ["hu", "hu"],
]);
